export default "__VITE_ASSET__0feb8e05__"